import React from 'react';
import { Redirect} from "react-router-dom";
import {userAuthContext} from '../context/userAuthContext';
import Auth from '../scripts/auth';
import {paths} from '../config/app-config';

const withAuth = ({Component, fromLocation}) => {
  return class extends React.PureComponent {
    state = {
      isUserAuthenticated: false,
      shouldDoBasicAuth: false,
      pageNotFound: false,
      loaded: false,
      allowedServices: {},
      done: false
    }

    componentDidMount() {
      Auth.loginWithSaml(paths)
        .then(response => {
          if(!response) {
            this.setState({ loaded: false });
          } else if([401,403].includes(response?.statusCode)) {
            this.setState({ shouldDoBasicAuth: true, loaded: true });
          } else if(response?.data) {
            this.setState({ isUserAuthenticated: true, shouldDoBasicAuth: false, loaded: true, allowedServices: response.data.allowedServices });
          } else {
            this.setState({ pageNotFound: true, loaded:true });
          }
        });
    }

    render() {
      return (
        <userAuthContext.Consumer>
          {(context) => {
            if(context.state.isUserAuthenticated) {
              return <Component />
            } else {
              if(this.state.isUserAuthenticated) {
                context.setAuthentication(true);
                context.setAllowedServices(this.state.allowedServices);
                this.setState({ done: true });
                return <Component />
              } else if(!this.state.isUserAuthenticated && this.state.shouldDoBasicAuth){
                // If SAML Login fails with 401,403, we switch the current login session to Basic Login session
                context.setCurrentLoginSession('BASIC');
                this.setState({ done: true });
                return <Redirect to={{ pathname: "/login" }}/>
              } else if(!this.state.isUserAuthenticated && !this.state.shouldDoBasicAuth && this.state.done) {
                return <Redirect to={{ pathname: "/403" }}/>
              } else if(!this.state.isUserAuthenticated && this.state.done){
                return <Redirect to={{ pathname: "/403" }}/>
              } else if(this.state.pageNotFound && this.state.loaded) {
                return <Redirect to={{ pathname: "/404" }}/>
              }
            }
          }}
        </userAuthContext.Consumer>
      )
    }
  }
}

export default withAuth;
